export const isEOIAllowedForFundStatus = (status: string): boolean => {
  return status === 'EOI' || status === 'APPLICATION_OPEN';
};

export const getFundStatusMessage = (status: string): string => {
  switch (status) {
    case 'UNDER_MANAGEMENT':
      return 'This fund is currently under management and is no longer accepting new or updated expressions of interest.';
    case 'COMPLETE':
      return 'This fund has completed its lifecycle and is no longer accepting expressions of interest.';
    case 'NEW':
    case 'APPROVED':
      return 'Expressions of interest are not currently available for this fund.';
    default:
      return 'Expressions of interest are not available at this time.';
  }
};
